import React from "react";
import PropTypes from "prop-types";

const propTypes = {
  loading: PropTypes.bool,
  size: PropTypes.number,
  usePadding: PropTypes.bool,
  title: PropTypes.string
};
function Loading({ loading = false, size = 3, usePadding = true, title = "" }) {
  if (!loading) return null;

  const padding = usePadding ? "p-4" : "";

  return (
    <div
      className={`d-flex align-items-center justify-content-center ${padding}`}
    >
      <i title={title} className={`fa fa-pulse fa-spinner fa-${size}x`} />
      <span className="sr-only">Loading...</span>
    </div>
  );
}

Loading.propTypes = propTypes;

export default Loading;
